import { Entity, Field } from "typegraph";

@Entity({create:"userTagCreate"})
export default class UserTagAction {

    @Field()
    public id: number;

    //@Field()
    public userId: number;

    //@Field()
    public tagId: number;

    //@Field()
    public tagIds: number[];

    //@Field()
    public sortIndex: number=0;

    //@Field()
    public clearExisting: boolean;

    //@Field()
    public clearExistingFromTagSetIds: number[];
}


// WEBPACK FOOTER //
// ./src/panels/recommended/userPreferences/entities/UserTagAction.ts